import { dataLayerWithConfig, initWithConfig } from "./manager";

export default {
  initializeWithConfig: initWithConfig,
  dataLayer: dataLayerWithConfig,
};
